import ListProductPage from './ListProductPage.jsx';

export {
  ListProductPage
}


// WEBPACK FOOTER //
// ./pages/list-product/index.js